module.exports = __webpack_public_path__ + "img/携程_03.17371633.jpg";